import { render, staticRenderFns } from "./booking-hour.input.vue?vue&type=template&id=651be5c8&"
import script from "./booking-hour.input.vue?vue&type=script&lang=ts&"
export * from "./booking-hour.input.vue?vue&type=script&lang=ts&"
import style0 from "./booking-hour.input.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports